<ada-container
	#MainContainer
	id="MainContainer"
	[horizontalSpacing]="'Medium'"
	[padding]="'[&#34;0px&#34;,&#34;1rem&#34;,&#34;0px&#34;,&#34;1rem&#34;]'"
	[verticalSpacing]="'Medium'"
>
	<ada-container
		#Container3
		id="Container3"
		[colCount]="0"
		[horizontalSpacing]="'Small'"
		[verticalAlignmentOfChildren]="'Middle'"
	>
		<ada-text
			#Text4
			id="Text4"
			[content]="'Week Setting'"
			[fontWeight]="'Bold'"
		/>
		<ada-signpost
			#Signpost1
			id="Signpost1"
			[icon]="'faInfoCircleOutline'"
		>
			<ada-text
				#Text1
				id="Text1"
				[content]="'This Schedule will occur once every X weeks on the specified day of the week. '"
			/>
		</ada-signpost>
	</ada-container>
	<ada-container
		#InputsContainer
		id="InputsContainer"
		[colCount]="4"
		[horizontalSpacing]="'Medium'"
		[verticalSpacing]="'Medium'"
	>
		<ada-text
			#Text2
			id="Text2"
			[content]="'Recurring Interval in Weeks'"
		/>
		<ada-container
			#Container1
			id="Container1"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-input
				#RecurringIntervalInWeeksInput
				id="RecurringIntervalInWeeksInput"
				[debounce]="'500'"
				[isDisabled]="isDisabled"
				[max]="'127'"
				[min]="'1'"
				[placeholder]="'Number of weeks'"
				[showAsFullWidth]="true"
				[type]="'Number'"
				[value]="numberOfWeeks"
				(valueChange)="setNumberOfWeeks($event)"
			/>
		</ada-container>
		<ada-text
			#Text3
			id="Text3"
			[content]="'Day of the Week'"
		/>
		<ada-container
			#Container2
			id="Container2"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-combo
				#DayOfTheWeekInput
				id="DayOfTheWeekInput"
				[isDisabled]="isDisabled"
				[options]="dayOptions"
				[showAsFullWidth]="true"
				[value]="dayOfWeek"
				(valueChange)="setDayOfWeek($event)"
			/>
		</ada-container>
	</ada-container>
</ada-container>
